import React from 'react';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { MoodashActivePlatforms } from '../dto/IDiscoveryFilter';

interface IDiscoveryInfluencerListProps {
    children: JSX.Element;
    selectedPlatform: string;
    influencersFound: string | number;
    isGlobalDiscovery?: boolean;
}

const DiscoveryInfluencerList = ({
    children,
    selectedPlatform,
    influencersFound,
    isGlobalDiscovery = false,
}: IDiscoveryInfluencerListProps) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="text-muted py-2 border-bottom d-none d-md-flex">
                <Col xs={2}>{t('brand.campaign.discovery.influencers_found', { nbInfluencers: influencersFound })}</Col>
                {!isGlobalDiscovery && <Col xs={2}>{t('brand.campaign.discovery.add_to_favorites')}</Col>}
                <Col xs={2}>
                    {selectedPlatform === MoodashActivePlatforms.INSTAGRAM
                        ? t('brand.campaign.discovery.followers')
                        : t('brand.campaign.discovery.subscribers')}
                </Col>
                <Col xs={2}>{t('brand.campaign.discovery.engagement_rate')}</Col>
                <Col xs={2}>
                    {selectedPlatform === MoodashActivePlatforms.INSTAGRAM
                        ? t('brand.campaign.discovery.engagements')
                        : t('brand.campaign.discovery.views')}
                </Col>
                <Col xs={2} className="text-end">
                    {t('brand.campaign.discovery.actions')}
                </Col>
            </div>
            {children}
        </>
    );
};

export default DiscoveryInfluencerList;
